export default __webpack_public_path__ + "static/media/gnome.4662bc1f.png";